module.exports = __webpack_public_path__ + "static/stratton-finance-00-hero-22c33b6bdd675aa8224316a7ab39c967.jpg";